import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SvgIconProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { NestedMenuItem } from 'mui-nested-menu';

export const defaultMenus: KebabMenuItem[] = [
    {
        label: "Download"
    },
    {
        label: "Export",
        children: [
            {
                label: "PDF"
            },
            {
                label: "CSV"
            }
        ]

    },
    {
        label: "Share"
    }
]

export interface KebabMenuItem {
    label: string;
    children?: KebabMenuItem[]
}

interface KebabMenuProps extends SvgIconProps {
    menus?: KebabMenuItem[];
    handler?: (name: string) => void;
}

export default function KebabMenu({ menus, handler, sx }: KebabMenuProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <IconButton sx={
                {
                    position: 'absolute',
                    top: 6,
                    right: 0,
                    zIndex: 100
                }
            } onClick={handleClick}>
                <MoreVertIcon sx={{
                    color: 'text.primary',
                    fontSize: 32
                }} />
            </IconButton>
            {<Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {
                    handler && menus && menus.map((menu, idx) => {

                        if (!menu.children) {
                            return (<MenuItem onClick={() => handler(menu.label)} key={idx}> {menu.label} </MenuItem>);
                        }

                        return (
                            <NestedMenuItem key={idx} label={menu.label} parentMenuOpen={open} sx={{
                                pl: 1,
                                pr: 1
                            }}>
                                {
                                    menu.children.map((childmenu, index) => {
                                        return <MenuItem key={index}>{childmenu.label}</MenuItem>
                                    })
                                }
                            </NestedMenuItem>);

                    })
                }
            </Menu>
            }
        </React.Fragment>
    )


}